import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { insertNewLine, generateKey } from '@/utils';
import Image from '../ContentfulImage';
import media from '../../styles/media.style';
import Section from '../Section';
import Slider from '../Slider/Slider';

const Contents = styled.div`
  ${media.tabletL`
    display: flex;
    flex-direction: ${({ left }) => (left ? 'row' : 'row-reverse')};
  `};
`;

const SliderContainer = styled.div`
  padding-bottom: 50px;

  ${media.tabletL`
    max-width: 675px;
    width: 50%;
  `};
`;

const Slide = styled.div``;

const Details = styled.div`
  ${media.tabletL`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 40px;
    padding-bottom: 50px;
    width: 500px;
  `};

  ${media.desktop`
    margin: ${({ imagePosition }) => (imagePosition ? '0 0 0 90px' : '0 90px 0 0')};
  `};
`;

const Description = styled.div`
  h1 {
    font-size: 24px;
    font-weight: 500;
    line-height: 1.08;
    letter-spacing: 0.2px;
    margin: 10px 0 0 0;

    ${media.tabletL`
      font-size: 32px;
      letter-spacing: 0.4px;
    `};
  }

  h2,
  h3 {
    font-size: 14px;
    line-height: 1.71;
    letter-spacing: 0.1px;
    margin: 0;

    ${media.tabletL`
      font-size: 18px;
      line-height: 1.33;
    `};
  }

  h3 {
    margin-top: 20px;

    ${media.tabletL`
      margin-top: 40px;
    `};
  }

  p {
    font-size: 18px;
    line-height: 1.33;
    letter-spacing: 0.1px;
    margin: 15px 0 0 0;
  }

  ul {
    padding-left: 20px;

    ${media.tabletL`
      padding-left: 0;
    `};
  }

  li {
    font-size: 14px;
    line-height: 1.29;
    letter-spacing: 0.1px;

    ${media.tabletL`
      font-size: 18px;
      line-height: 1.33;
      letter-spacing: 0.1px;
      margin: 15px 0 0 0;
    `};
  }
`;

const CarouselSection = ({ entryId, images, description, imagePosition }) => (
  <Section id={entryId} options={{ inner: { locked: true } }}>
    <Contents left={imagePosition}>
      {images && (
        <SliderContainer>
          {images.length > 1 ? (
            <Slider dots keys={images.map(image => image.assetId)} options={{ loop: true }}>
              {images.map((image, index) => (
                <Slide key={generateKey('carousel-section', index)}>
                  <Image src={image} options={{ size: [560, 860, 600, 675] }} />
                </Slide>
              ))}
            </Slider>
          ) : (
            <Image src={images[0]} options={{ size: [560, 860, 600, 675] }} />
          )}
        </SliderContainer>
      )}

      <Details imagePosition={imagePosition}>
        {insertNewLine({ key: 'carousel-section', description, component: Description })}
      </Details>
    </Contents>
  </Section>
);

CarouselSection.propTypes = {
  entryId: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  imagePosition: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
};

export default CarouselSection;



// WEBPACK FOOTER //
// ./src/components/Article/CarouselSection.js